import React from "react";
import { Layout } from "../../containers";
import { Container } from "./styled";

function Glosary() {
  return (
    <Layout>
      <Container>
        <div className="extra-container">
          <h1>Glosario de estadísticas avanzadas de básquet</h1>
          <div className="description-container">
            <h2>Efectividad de tiros de campo</h2>
            <p>
              Esta estadística da más importancia a los 3 puntos. Para ser
              exactos, con esta estadística un tres puntos vale 1,5 veces más
              que un 2 puntos. Cuando un jugador anota 4/10 (FG% = 40%) y todos
              sus tiros son de 3 puntos, su efg% será del 60%. La fórmula no
              incluye tiros libres a diferencia del ts%.
            </p>
            <p>
              <b>Formula</b>
              <br />
              <i>
                eFG%= [(Todos los tiros de campo anotados) + 0,5*(Goles de campo
                3P anotados)]/(Todos los intentos de tiros de campo)
              </i>
            </p>
          </div>
          <div className="description-container">
            <h2>Tasa de tiros libres</h2>
            <p>
              Proporción de tiros libres intentados según el número de tiros
              realizados. Ante la importancia de situarse regularmente en la
              línea de tiros libres durante un partido, podemos considerar que
              un equipo que tiene un alto índice de tiros libres optimiza sus
              posibilidades de ganar.
            </p>
            <p>
              <b>Formula</b>
              <br />
              <i>
                FTR%= (Total de tiros libres intentados) / (Total de goles de
                campo intentados)
              </i>
            </p>
          </div>
          <div className="description-container">
            <h2>Eficiencia ofensiva</h2>
            <p>
              Cuántos puntos anota un jugador o un equipo por cada 100
              posesiones.
            </p>
            <p>
              <b>Formula</b>
              <br />
              <i>EO%= 100*(Puntos Anotados / Posesiones)</i>
            </p>
          </div>
          <div className="description-container">
            <h2>Eficiencia defensiva</h2>
            <p>
              Cuántos puntos permite un jugador o un equipo por cada 100
              posesiones.
            </p>
            <p>
              <b>Formula</b>
              <br />
              <i>ED%= 100*(Puntos Permitidos / Posesiones)</i>
            </p>
          </div>
          <div className="description-container">
            <h2>Tasa de perdidas</h2>
            <p>
              Mide el porcentaje de posesiones que terminan con una pérdida de
              balón.
            </p>
            <p>
              <b>Formula</b>
              <br />
              <i>TOR%= (Peridas * 100) / (Posesiones)</i>
            </p>
          </div>
          <div className="description-container">
            <h2>Porcentaje de rebotes ofensivos</h2>
            <p>
              El porcentaje de rebotes ofensivos mide la capacidad de un equipo
              para conseguir rebotes ofensivos.
            </p>
            <p>
              <b>Formula</b>
              <br />
              <i>
                OREB%= (Rebotes ofensivos)/[(Rebotes ofensivos)+(Rebotes
                defensivos del oponente)])
              </i>
            </p>
          </div>
          <div className="description-container">
            <h2>Porcentaje de rebotes defensivos</h2>
            <p>
              El porcentaje de rebotes ofensivos mide la capacidad de un equipo
              para conseguir rebotes defensivos.
            </p>
            <p>
              <b>Formula</b>
              <br />
              <i>
                DREB%= (Rebotes defensivos del equipo)/[(Rebotes defensivos del
                equipo)+Rebotes ofensivos del oponente)]
              </i>
            </p>
          </div>
          <div className="description-container">
            <h2>Posesiones Por Partido(POSS)</h2>
            <p>
              Esta fórmula estima las posesiones basándose tanto en las
              estadísticas del equipo como en las del oponente, luego las
              promedia para proporcionar una estimación más estable.
            </p>
            <p>
              <b>Formula</b>
              <br />
              <i>
                POSS= (0,5*((Intentos de tiros de campo + 0,4*Intentos de tiros
                libres – 1,07*(Rebotes ofensivos/(Rebotes ofensivos + Rebotes
                defensivos del oponente))*(Intentos de tiros de campo – Tiros de
                campo convertidos) + Pérdidas de balón) + (Intentos de tiros de
                campo del oponente + 0,4*(Intentos de tiros libres del oponente)
                – 1,07*(Rebotes ofensivos del oponente)/(Rebotes ofensivos del
                oponente + Rebotes defensivos))*(Intentos de tiros de campo del
                oponente – Tiros de campo del oponente) + Pérdidas de balón del
                oponente))) / partidos jugados
              </i>
            </p>
          </div>
          <div className="description-container">
            <h2>Asistencias por posesion</h2>
            <p>Mide el porcentaje de posesiones que terminan en asistencia.</p>
            <p>
              <b>Formula</b>
              <br />
              <i>APP= (Asistencias * 100) / (Posesiones)</i>
            </p>
          </div>
          <div className="description-container">
            <h2>Porcentaje real de tiro(TS%)</h2>
            <p>
              Esta estadística acumula los diferentes tipos de tiros que puede
              realizar un jugador: 2 puntos, 3 puntos y tiros libres.
            </p>
            <p>
              <b>Formula</b>
              <br />
              <i>
                TS%= Puntos anotados / (Tiros de campo intentados + 0,44 * tiros
                libros intentados)
              </i>
            </p>
          </div>
          <div className="description-container">
            <h2>Puntos por posesión(PPP)</h2>
            <p>
              Puntos por posesión es una estadística avanzada que intenta medir
              la cantidad de puntos que genera un equipo o jugador por cada
              posesión del balón.
            </p>
            <p>
              <b>Formula</b>
              <br />
              <i>PPP=PTS/(FGA+0.44*FTA+TO)</i>
            </p>
          </div>
          <div className="description-container">
            <h2>Adjusted Four Factors(a4f)</h2>
            <p>
              Cuatro factores ajustados, calculados aplicando ponderaciones a
              los diferenciales de los cuatro factores ofensivos y defensivos.
              A4F explica la proporción específica de variabilidad en las
              victorias.
            </p>
          </div>
          <div className="description-container">
            <h2>PACE</h2>
            <p>Una estimación de posesiones por 40 minutos.</p>
            <p>
              <b>Formula</b>
              <br />
              <i>PACE=[200/(minutosEquipo)]*(POSS+oppPOSS)/2</i>
            </p>
          </div>
          <div className="description-container">
            <h2>USAGE</h2>
            <p>
              La tasa de uso es una estimación del porcentaje de jugadas de
              equipo utilizadas por un jugador mientras estaba en la cancha.
            </p>
            <p>
              <b>Formula</b>
              <br />
              <i>
                USG=100*((Intentos de tiros de campo + 0.44 * (Intentos de tiros
                libres + Pérdidas de balón) * (Total de minutos del equipo)) /
                (Total de intentos de tiros de campo del equipo) + 0.44 * (Total
                de intentos de tiros libres del equipo + Total de pérdidas de
                balón del equipo) * 5 * Minutos del jugador)
              </i>
            </p>
          </div>
        </div>
      </Container>
    </Layout>
  );
}

export default Glosary;
